import { Clock } from 'lucide-react'
import { useRecentlyRead } from '../api/hooks'
import { ArticleListView } from '../components/mywire/ArticleListView'

export default function ReadingHistoryPage() {
  const { data, isLoading } = useRecentlyRead(30)

  return (
    <ArticleListView
      articles={data?.items ?? []}
      isLoading={isLoading}
      isFullyLoaded={!isLoading}
      title="Recently Read"
      icon={Clock}
      emptyTitle="Nothing here yet."
      emptySubtitle="Articles you read will show up here."
    />
  )
}
